async function textFetch(url) {
  try {
    const response = await fetch(url, {
      headers: { accept: "application/text" },
    });

    if (!response.ok) {
      throw new Error(response.err);
    }
    const json = await response.text();

    return json;
  } catch (err) {
    console.error(`Error fetching ${url}`, err);
    throw err;
  }
}

function getHexDownloadUrl(hexagonsResolution, country, state, start, end) {
  return `${process.env.REACT_APP_API_URL}/api/download/hex?start=${start}&end=${end}&resolution=${hexagonsResolution}&country=${country}&state=${state}`;
}

function getCountriesDownloadUrl(baseline, start, end) {
  return `${process.env.REACT_APP_API_URL}/api/download/countries?start=${start}&end=${end}&baseline=${baseline}`;
}

function getStatesDownloadUrl(country, baseline, start, end) {
  return `${process.env.REACT_APP_API_URL}/api/download/states?start=${start}&end=${end}&baseline=${baseline}&country=${country}`;
}

function getCountiesDownloadUrl(country, state, baseline, start, end) {
  return `${process.env.REACT_APP_API_URL}/api/download/counties?start=${start}&end=${end}&baseline=${baseline}&country=${country}&state=${state}`;
}

function getCensusTractsDownloadUrl(country, state, baseline, start, end) {
  return `${process.env.REACT_APP_API_URL}/api/download/census_tract?start=${start}&end=${end}&baseline=${baseline}&country=${country}&state=${state}`;
}

// if (process.env.NODE_ENV === "development") {
//   firebase.functions().useFunctionsEmulator("http://localhost:5001");
//  }

// const download = firebase.functions().httpsCallable("download");

async function download({
  level,
  country,
  state,
  start,
  end,
  baseline,
  hexagons,
}) {

  let url;
  let filename;

  if (hexagons) {
    filename = `hex_${hexagons}_${country}_${state}.csv`;
    url = getHexDownloadUrl(hexagons, country, state, start, end);
  } else if (level === 3 && country && state) {
    filename = `level_3_${country}_${state}.csv`;
    url = getCensusTractsDownloadUrl(country, state, baseline, start, end);
  } else if (level === 2 && country && state) {
    filename = `level_2_${country}_${state}.csv`;
    url = getCountiesDownloadUrl(country, state, baseline, start, end);
  } else if (level === 1 && country) {
    filename = `level_1_${country}.csv`;
    url = getStatesDownloadUrl(country, baseline, start, end);
  } else if (level === 0) {
    filename = `level_0.csv`;
    url = getCountriesDownloadUrl(baseline, start, end);
  } else {
    throw Error("Invalid download");
  }

  const result = await textFetch(url);
  return { data: result, filename };
}

export default download;
